module.exports = __webpack_public_path__ + "static/img/application (1).1bf9589.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/application (1).png
// module id = wfbS
// module chunks = 73